import React from "react";
import "./ProductTableHeader.css";

const ProductTableHeader = ({
  selectedProducts,
  currentProducts,
  handleSelectAll,
  limitedFields,
  formatFieldName,
}) => {
  const allSelected =
    selectedProducts.length === currentProducts.length &&
    currentProducts.length > 0;

  // ✅ Check if at least one product has a status object with keys
  const showStatusColumn = currentProducts.some(
    (p) =>
      p.status &&
      typeof p.status === "object" &&
      Object.keys(p.status).length > 0
  );

  return (
    <thead className="advanceProduct-table-header">
      <tr className="advanceProduct-table-header-row">
        <th className="header-cell checkbox-cell">
          <span
            className="checkbox-icon-wrapper"
            onClick={handleSelectAll}
            title={allSelected ? "Deselect All" : "Select All"}
          >
            <i
              className={`fa-regular ${
                allSelected ? "fa-square-check" : "fa-square"
              } select-all-checkbox-icon`}
            ></i>
          </span>
        </th>

        {showStatusColumn && (
          <th className="header-cell status-header">Status</th>
        )}

        {limitedFields
          .filter(
            (field) => !["password", "plainPassword"].includes(field.fields)
          )
          .map((field, index) => (
            <th
              key={`${field.fields}-${index}`}
              title={field.inotations || formatFieldName(field.fields)}
              className={`header-cell field-header field-${field.fields}`}
            >
              {field.title || formatFieldName(field.fields)}
            </th>
          ))}
      </tr>
    </thead>
  );
};

export default ProductTableHeader;
